export default function currencyFilter(input) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0, // this removes the .00 from the currency value
  })

  return `${formatter.format(input)}`
}
